export var PhoneCallStatus;
(function (PhoneCallStatus) {
    PhoneCallStatus[PhoneCallStatus["PENDING"] = 100] = "PENDING";
    PhoneCallStatus[PhoneCallStatus["CANCELLED_BY_PHONE"] = 110] = "CANCELLED_BY_PHONE";
    PhoneCallStatus[PhoneCallStatus["CANCELLED_BY_WEB"] = 120] = "CANCELLED_BY_WEB";
    PhoneCallStatus[PhoneCallStatus["CANCELLED_BY_AGENT"] = 125] = "CANCELLED_BY_AGENT";
    PhoneCallStatus[PhoneCallStatus["ABANDONED"] = 130] = "ABANDONED";
    PhoneCallStatus[PhoneCallStatus["USER_DID_NOT_ANSWER"] = 140] = "USER_DID_NOT_ANSWER";
    PhoneCallStatus[PhoneCallStatus["FINISHED"] = 150] = "FINISHED";
})(PhoneCallStatus || (PhoneCallStatus = {}));
;
//# sourceMappingURL=phone-call-status.enum.js.map